import React from 'react'
import "./WithoutPasswordScreen.css"
import { Background } from '../../../assets/logos'

export default function WithoutPasswordScreen() {
    return (
        <div className='main-container'>
            <p className='text-styles'>
                Gracias por usar Govo.Digital.
            </p>
            <img className='img-styles' src={Background} />
        </div>
    )
}